import { createElement as CustomCreateElement } from '../CustomCreateElement'

function FeatureGlobeIcon(): JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="#1199FA"
        fillRule="evenodd"
        d="M12 1.75C6.34 1.75 1.75 6.34 1.75 12S6.34 22.25 12 22.25 22.25 17.66 22.25 12 17.66 1.75 12 1.75zM.25 12C.25 5.51 5.51.25 12 .25S23.75 5.51 23.75 12 18.49 23.75 12 23.75.25 18.49.25 12z"
        clipRule="evenodd"
      />
      <path
        fill="#1199FA"
        fillRule="evenodd"
        d="M12.434.607a.75.75 0 011.059-.073C16.748 3.37 18.75 7.474 18.75 12c0 4.622-1.998 8.732-5.268 11.475a.75.75 0 11-.964-1.15c2.93-2.457 4.732-6.147 4.732-10.325 0-4.073-1.799-7.77-4.743-10.334a.75.75 0 01-.072-1.059zM11.575.618a.75.75 0 01-.093 1.057C8.552 4.132 6.75 7.822 6.75 12c0 4.073 1.798 7.77 4.743 10.334a.75.75 0 01-.986 1.132C7.252 20.63 5.25 16.526 5.25 12c0-4.622 1.998-8.732 5.268-11.475a.75.75 0 011.057.093z"
        clipRule="evenodd"
      />
      <path
        fill="#1199FA"
        fillRule="evenodd"
        d="M12 .25a.75.75 0 01.75.75v22a.75.75 0 01-1.5 0V1A.75.75 0 0112 .25z"
        clipRule="evenodd"
      />
      <path
        fill="#1199FA"
        fillRule="evenodd"
        d="M1.25 8A.75.75 0 012 7.25h20a.75.75 0 010 1.5H2A.75.75 0 011.25 8zM1.25 16a.75.75 0 01.75-.75h20a.75.75 0 010 1.5H2a.75.75 0 01-.75-.75z"
        clipRule="evenodd"
      />
    </svg>
  )
}

export default FeatureGlobeIcon
